<script>
  export let name;
  export let Style;
  export let btnRemove;
</script>

<div class="{Style} rounded subcateogry-name d-inline-block px-2 py-1 mb-1">
  <div class="  d-flex flex-row justify-content-between align-items-center">
    <span class=" ">{name}</span>
    {#if btnRemove == true}
      <button class="btn btn-link px-0 mb-0 shadown-none border-0 p-0 me-1 ms-2">
        <img
          class="icon-10"
          alt=""
          src="/images/cancel.svg"
        />
      </button>
    {/if}
  </div>
</div>

<style lang="scss">
  .subcateogry-name {
    background-color: rgba($input-border-color, 0.3);
    padding: 3px;
  }
</style>
